import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import FeatureIconSingle from "../../components/feature-icon/FeatureIconSingle";
import { AuthContext } from "../../common/Auth"
import ActionGridEditIcon from "../../pages/actionGrid/ActionGridEditIcon"

const FeatureIcon = ({ actionGridList }) => {

  const { themeSettingsData } = useContext(AuthContext)
  const [iconData, setIconData] = useState({})
  const [iconId, setIconId] = useState("")

  useEffect(() => {
    if (themeSettingsData && themeSettingsData.length && themeSettingsData.length > 0) {
      themeSettingsData.map((i) => {
        if (i.settingsName === "iconFreeShipping") {
          setIconData(i.values[0]);
          setIconId(i._id);
        }
      })
    }
  }, [themeSettingsData])

  let pt = iconData.paddingTop ? iconData.paddingTop : "pt-0";
  let pb = iconData.paddingBottom ? iconData.paddingBottom : "pb-0";
  let mb = iconData.marginBottom ? iconData.marginBottom : "mb-50";
  let mt = iconData.marginTop ? iconData.marginTop : "mt-50";
  let mr = iconData.marginRight ? iconData.marginRight : "mr-0";
  let ml = iconData.marginLeft ? iconData.marginLeft : "ml-0";
  let pl = iconData.paddingLeft ? iconData.paddingLeft : "pl-0";
  let pr = iconData.paddingRight ? iconData.paddingRight : "pr-0";
  let fullSection = iconData.fullSection ? "container-fluid" : "container";
  let bgImage = iconData?.bgImage ? iconData?.bgImage : "";
  let bgColor = iconData?.bgColor ? iconData?.bgColor : "";

  return (
    <div
      className={`antera-action-grid-section-container support-area section-bgImage  ${pt} ${pb} ${mb} ${mt} ${mr} ${ml} ${pl} ${pr}`}
      style={(bgImage.length > 0 ) ? {backgroundImage:`url(${bgImage})`} : {background:bgColor}}
    >
      <div className={`antera-action-grid-content-container ${fullSection}`}>
        <div className="edit-inline">
          <ActionGridEditIcon actionGridId={iconId} fromEditAction="topBottomSpace" />
        </div>
        <div className="antera-action-grid-content row grid-text-center">
          {actionGridList && actionGridList.map(singleFeature => {
            return (
              <FeatureIconSingle
                singleFeature={singleFeature}
                key={singleFeature._id}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

FeatureIcon.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default FeatureIcon;
